import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-admin-manage-shift-blue-dart',
  templateUrl: './admin-manage-shift-blue-dart.component.html',
  styleUrls: ['./admin-manage-shift-blue-dart.component.scss'],
})
export class AdminManageShiftBlueDartComponent implements OnInit {
  blueDartData: any = {};
  licenseKeyError: string;
  customerCodeError: string;
  carrierNameError: string;
  userNameError: string;
  versionError: string;
  passwordError: string;
  apiTypeError: string;
  areaError: string;
  carrierId: any;
  constructor(private api: ApiIntegration, private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

    this.carrierId = this.route.snapshot.paramMap.get('id');
    if (this.carrierId) {
      this.api.adminGetCarrierInfoById(this.carrierId, this.user.organizationId).subscribe((data: any) => {
        this.blueDartData = data;
      }, err => {
        this.alertService.error('Error', err);
      });
    }

  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.blueDartData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  licenseKeyBlur() {
    this.licenseKeyError = "";
    if (!this.blueDartData.licenceKey) {
      this.licenseKeyError = 'Please enter license key';
    }
  }

  customerCodeBlur() {
    this.customerCodeError = "";
    if (!this.blueDartData.customerCode) {
      this.customerCodeError = 'Please enter customer code';
    }
  }

  userNameBlur() {
    this.userNameError = "";
    if (!this.blueDartData.username) {
      this.userNameError = 'Please enter user name';
    }
  }

  versionBlur() {
    this.versionError = "";
    if (!this.blueDartData.version) {
      this.versionError = 'Please enter version';
    }
  }

  passwordBlur() {
    this.passwordError = "";
    if (!this.blueDartData.password) {
      this.passwordError = 'Please enter password';
    }
  }

  apiTypeBlur() {
    this.apiTypeError = "";
    if (!this.blueDartData.apiType) {
      this.apiTypeError = 'Please enter api type';
    }
  }

  areaBlur() {
    this.areaError = "";
    if (!this.blueDartData.area) {
      this.areaError = 'Please enter area';
    }
  }

  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.licenseKeyError = "";
    this.customerCodeError = "";
    this.userNameError = "";
    this.versionError = "";
    this.passwordError = "";
    this.apiTypeError = "";
    this.areaError = "";

    if (!this.blueDartData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.blueDartData.licenceKey) {
      this.licenseKeyError = 'Please enter license key';
    }
    if (!this.blueDartData.customerCode) {
      this.customerCodeError = 'Please enter customer code';
    }
    if (!this.blueDartData.username) {
      this.userNameError = 'Please enter user name';
    }
    if (!this.blueDartData.version) {
      this.versionError = 'Please enter version';
    }
    if (!this.blueDartData.password) {
      this.passwordError = 'Please enter password';
    }
    if (!this.blueDartData.apiType) {
      this.apiTypeError = 'Please enter api type';
    }
    if (!this.blueDartData.area) {
      this.areaError = 'Please enter area';
    }
    if (this.carrierNameError != "" || this.licenseKeyError != "" || this.customerCodeError != "" || this.userNameError != "" || this.versionError != "" || this.passwordError != "" || this.apiTypeError != "" || this.areaError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body


    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCarrierCredentials', {

      "carrierCode": this.blueDartData.carrierCode,
      "connectionName": this.blueDartData.connectionName,
      "organizationId": 1,
      "apiType": this.blueDartData.apiType,
      "area": this.blueDartData.area,
      "version": this.blueDartData.version,
      "customerCode": this.blueDartData.customerCode,
      "licenceKey": this.blueDartData.licenceKey,
      "password": this.blueDartData.password,
      "username": this.blueDartData.username,
      "carrierId": this.blueDartData.carrierId,


    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Blue Dart', 'Create Successfully');
          this.router.navigate(['/admin/adminCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}

